import { compose } from 'recompose';

import ColData from './colData';

const enhance = compose();
export default enhance(ColData);
